var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleGreenNetworkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42104 11.0879V12.2112C4.5842 11.5715 3.26315 9.8345 3.26315 7.80103C3.26315 5.22149 5.38946 3.12041 7.99999 3.12041C10.6105 3.12041 12.7368 5.22149 12.7368 7.80103C12.7368 9.8345 11.4158 11.5715 9.57894 12.2112V11.0879C10.821 10.5054 11.6842 9.25202 11.6842 7.80103C11.6842 5.79356 10.0316 4.16055 7.99999 4.16055C5.96841 4.16055 4.31578 5.79356 4.31578 7.80103C4.31578 9.25202 5.17894 10.5054 6.42104 11.0879ZM1.15789 7.80103C1.15789 4.07214 4.22631 1.04014 7.99999 1.04014C11.7737 1.04014 14.8421 4.07214 14.8421 7.80103C14.8421 10.9943 12.5947 13.6726 9.57894 14.3799V15.446C13.1789 14.7226 15.8947 11.5663 15.8947 7.80103C15.8947 3.50006 12.3526 0 7.99999 0C3.64736 0 0.105255 3.50006 0.105255 7.80103C0.105255 11.5663 2.82104 14.7231 6.42104 15.446V14.3799C3.40525 13.6726 1.15789 10.9943 1.15789 7.80103ZM8.52631 18.7225V8.69711C8.83999 8.51664 9.05262 8.18536 9.05262 7.80103C9.05262 7.22687 8.58104 6.76089 7.99999 6.76089C7.41894 6.76089 6.94736 7.22687 6.94736 7.80103C6.94736 8.18484 7.16052 8.51664 7.47367 8.69711V18.7225H3.26315V19.7626H12.7368V18.7225H8.52631Z",
    fill: "#8EBD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleGreenNetworkIcon);
export default __webpack_public_path__ + "static/media/LittleGreenNetworkIcon.1d3b0665bf185ba9fc074995288ae019.svg";
export { ForwardRef as ReactComponent };